module.exports = __webpack_public_path__ + "media/common/images/cta/judith-ee4201b6b4d1d110fa33b57491cf641b.jpeg";